// @ts-nocheck
import { Plugin } from '/home/user/upos-dev/app/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
